import React from "react";
import { FiSearch } from "react-icons/fi";
import PayoutDropdown from "./PayoutDropdown";

type PayoutSearchFilterProps = {
  value: string;
  filterBy: string;
  filterOptions: string[];
  placeholder?: string;
  className?: string;
  onChange: (value: string) => void;
  onFilterByChange: (value: string) => void;
};

function PayoutSearchFilter({
  value,
  filterBy,
  filterOptions,
  placeholder = "Search",
  className = "",
  onChange,
  onFilterByChange,
}: PayoutSearchFilterProps) {
  return (
    <div
      className={
        "payout-filter-search payout-search-with-filter flex h-10 min-w-0 items-center rounded-[6px] border border-[#E0E5F2] bg-white " +
        className
      }
    >
      <input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className="h-full min-w-0 flex-1 bg-transparent px-3 text-sm font-semibold text-[#1B163B] outline-none placeholder:text-[#A3AED0]"
      />
      <span className="h-6 w-px shrink-0 bg-[#A3AED0]" />
      <PayoutDropdown
        value={filterBy}
        options={filterOptions}
        onChange={onFilterByChange}
        className="w-[150px] shrink-0"
        buttonClassName="h-full border-0 bg-transparent px-3 text-xs font-semibold shadow-none"
      />
      <button
        type="button"
        aria-label="Search"
        className="flex h-full w-10 shrink-0 items-center justify-center text-[#1B163B]"
      >
        <FiSearch className="text-base" />
      </button>
    </div>
  );
}

export default PayoutSearchFilter;
